import { normalizeValue } from './normalizeValue';

export function upperCaseValue(value: string | undefined): string | undefined {
	const trimmed = normalizeValue(value);
	if (!trimmed) {
		return undefined;
	}

	return trimmed.toLocaleUpperCase('en-US');
}
